import axios, { AxiosInstance, AxiosError } from 'axios'
import { API_URL } from '../lib/constants'
import type { APIError } from '../types/api.types'

/**
 * Axios instance configured for SignWiz API
 */
export const apiClient: AxiosInstance = axios.create({
  baseURL: API_URL,
  timeout: 30000, // 30 seconds
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor
apiClient.interceptors.request.use(
  config => {
    // Add auth token if exists (future)
    // const token = localStorage.getItem('auth_token')
    // if (token) {
    //   config.headers.Authorization = `Bearer ${token}`
    // }

    return config
  },
  error => Promise.reject(error)
)

// Response interceptor
apiClient.interceptors.response.use(
  response => response,
  (error: AxiosError<APIError>) => {
    // Handle common errors
    if (error.response) {
      // Server responded with error
      const apiError: APIError = {
        detail: error.response.data?.detail || 'Error en el servidor',
        status_code: error.response.status,
      }
      return Promise.reject(apiError)
    } else if (error.request) {
      // No response received
      const apiError: APIError = {
        detail: 'No se pudo conectar con el servidor',
        status_code: 0,
      }
      return Promise.reject(apiError)
    } else {
      // Other error
      const apiError: APIError = {
        detail: error.message || 'Error desconocido',
        status_code: -1,
      }
      return Promise.reject(apiError)
    }
  }
)
